export default {
    sex: ["M", "F", "X"]
}